import "./InternationalSeo.module.css";
import Header from "@/reusable_sections/Header";
import Heroglobal from "./sections/Heroglobal";
import WhatIsInternationalSeo from "./sections/WhatIsInternationalSeo";
import InternationalAudience from "./sections/InternationalAudience";
import InternationalStrategy from "./sections/InternationalStrategy";
import InternationalKeywordResearch from "./sections/InternationalKeywordResearch";
import MultilingualLocalisation from "./sections/MultilingualLocalisation";
import HreflangInternationalSeo from "./sections/HreflangInternationalSeo";
import ArchitectureComparison from "./sections/ArchitectureComparison";
import InternationalConsiderations from "./sections/InternationalConsiderations";
import InternationalAuthority from "./sections/InternationalAuthority";
import Process from "./sections/Process";
import MeasuringInternationalSEOPerformance from "./sections/MeasuringInternationalSEOPerformance";
import SeoComparison from "./sections/SeoComparison";
import Internationalseofaq from "./sections/Internationalseofaq";
import Globalexpansioncta from "./sections/Globalexpansioncta";
import Footer from "@/reusable_sections/Footer";
export default function InternationalSeoPage() {
  return <div>
      <Header />
      <Heroglobal />
      <WhatIsInternationalSeo />
      <InternationalAudience />
      <InternationalStrategy />
      <InternationalKeywordResearch />
      <MultilingualLocalisation />
      <HreflangInternationalSeo />
      <ArchitectureComparison />
      <InternationalConsiderations />
      <InternationalAuthority />
      <Process />
      <MeasuringInternationalSEOPerformance />
      <SeoComparison />
      <Internationalseofaq />
      <Globalexpansioncta />
      <Footer />
    </div>;
}